import { all } from 'redux-saga/effects';

import programDetailSaga from './programDetail';
import programDetailSimpleSaga from './programDetailSimple';
import programMoreEpisodeSaga from './moreEpisode';
import tvguideSaga from './tvguide';
import channelSaga from './channels';

export default function* rootSaga() {
  yield all([
    programDetailSaga(),
    programDetailSimpleSaga(),
    programMoreEpisodeSaga(),
    tvguideSaga(),
    channelSaga(),
  ]);
}
